import script from "./SearchOpenCloseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchOpenCloseButton.vue?vue&type=script&setup=true&lang=ts"

import "./SearchOpenCloseButton.vue?vue&type=style&index=0&id=5a0e0972&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0e0972"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
